module.exports = __webpack_public_path__ + "img/assinador.c967eb79.png";